import type { UserEntity } from "../../model";

import { SLASH } from "~/shared/str";

const BASE_URL = "users";

const URLS = {
  create: BASE_URL,
  update: BASE_URL,
  delete: (serviceId: UserEntity.Schema["id"]) => [BASE_URL, serviceId].join(SLASH),
  assignRoles: [BASE_URL, "roles"].join(SLASH),
  get: (serviceId: UserEntity.Schema["id"]) => [BASE_URL, serviceId].join(SLASH),
  getAll: BASE_URL,
  getPaginated: [BASE_URL, "getPage"].join(SLASH),
};

export { URLS };
